


export class AuthorThemedLotsView {

    constructor() {

        this.id = 'author-lots';
		
		this.box = document.getElementById(this.id);
		if (!this.box) {
			return false;
		}
		
		this.title = this.box.querySelector('.sc_title > strong');
		
		this.ul = this.box.querySelector('.ul');
		
		this.liTemplate = this.ul.querySelector('.li')?.cloneNode();
		this.itemTemplate = this.ul.querySelector('.lot')?.cloneNode(true);	
    }

    render(state) { 

		if (!state.data) { return false;}

		if (!this.box) { return false;}
		if (!this.ul) { return false;}

		const data = state.data;
		
		if (data.title) { this.title.textContent = data.title;}

		if (data.models) {
			
			const dummies = this.ul.querySelectorAll('.lot.dummy');
			dummies.forEach((el, index) => {
				
				const model = data.models[index];

				//если данных больше нет, удаляем лишний .item со скелетоном
				if (!model) {
					el.parentElement.remove();
					return;
				}
				
				//id:
				el.dataset.id = model.id;
				
				//url для ссылок
				const titleLink = el.querySelector('a.title');
				titleLink.href = model.url;
				
				el.querySelector('a.preview').href = model.url;
				
				//изображение
				const img = el.querySelector('img');
				if (img) {
					img.src = model.image;
					img.dataset.src = model.image;
					img.alt = model.title || '';
				}

				//заголовок
				titleLink.textContent = model.title;

				//цена и валюта
				el.querySelector('.price p').textContent = model.price;
				el.querySelector('.price span').textContent = model.currency;

				//снимаем класс скелетона
				el.classList.remove('dummy');
			});

			//удаляем пустые слайды .li (если пришедших данных было меньше изначального кол-ва скелетонов)
			this.ul.querySelectorAll('.li').forEach((li) => {
				if (!li.textContent.trim() && li.children.length === 0) { li.remove();}
			});
			
			//пустой блок не должен отображаться:
			this.box.style.display = (this.ul.querySelector('.li')) ? '' : 'none';
			
			this.box.classList.remove('dummy');
		}
    }
}